export enum UserBusinessType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
    INDEPENDENT = 'INDEPENDENT',
    DMC = 'DMC'
}
